import { httpGet } from 'utils';

export interface IManagementFeeSettingResponse {
  userId: string;
  accountHolderId: number;
  monthlyFee?: number | null;
  annuallyFee?: number | null;
  paidDateTime?: string | null;
  paidAmount?: number | null;
  showModal: boolean;
  lockout: boolean;
  createdDateTime: string;
  updatedDateTime: string;
}

export const fetchMgmtFeeStatus = async () => {
  return httpGet<IManagementFeeSettingResponse>('portal/ManagementFeeSetting');
};
